import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import get from 'lodash/get';

/** Actions */
export const BINARY_OPTION_DISCRETIONARY_ADD_ONS =
  'BINARY_OPTION_DISCRETIONARY_ADD_ONS';
export const UPDATE_BINARY_OPTION_DISCRETIONARY_ADD_ON =
  'UPDATE_BINARY_OPTION_DISCRETIONARY_ADD_ON';

/** Routines */
export const fetchBinaryOptionDiscretionaryAddOns = createRoutine(
  BINARY_OPTION_DISCRETIONARY_ADD_ONS,
);
export const updateBinaryOptionDiscretionaryAddOn = createRoutine(
  UPDATE_BINARY_OPTION_DISCRETIONARY_ADD_ON,
);

/** Promise */
export const updateBinaryOptionDiscretionaryAddOnPromise = promisifyRoutine(
  updateBinaryOptionDiscretionaryAddOn,
);

/** Reducer */
export default handleActions(
  {
    [fetchBinaryOptionDiscretionaryAddOns.SUCCESS]: (state, { payload }) => {
      // Backend returns { count, accounts }
      // Normalize to { data, count }
      return {
        ...state,
        data: get(payload, 'accounts', []),
        count: get(payload, 'count', 0),
      };
    },
  },
  { data: [], count: 0 },
);

/** Selectors */
const getBinaryOptionDiscretionaryAddOnState = (state) =>
  get(state, 'binaryOptionDiscretionaryAddOn', { data: [], count: 0 });

export const getBinaryOptionDiscretionaryAddOnData = createSelector(
  [getBinaryOptionDiscretionaryAddOnState],
  (state) => get(state, 'data', []),
);

export const getBinaryOptionDiscretionaryAddOnCount = createSelector(
  [getBinaryOptionDiscretionaryAddOnState],
  (state) => get(state, 'count', 0),
);
